// extracted by mini-css-extract-plugin
export default {"title":"taa-z","warning":"uaa-z","sizeOptionsLegendText":"vaa-z"};